import React from 'react';
import Basepage, { BasePageState } from '../Basepage';

interface FAQState extends BasePageState {}
interface FAQPModel {}

export default class FAQPage extends Basepage<FAQState, FAQPModel> {
  renderChild(): JSX.Element {
    return (
      <div id="FAQ">
        <b>FAQ - Häufige Fragen an den Buchbutler</b>
        <br />
        <br />
        <li>
          <b> Wie liefert der Buchbutler</b>
          <ul>
            {' '}
            der Buchbutler liefert aktuell ausschließlich per DHL Paket und
            Warenpost, ggfs als Großbrief.
          </ul>
          <ul>
            {' '}
            der Buchbutler ist NICHT dem Bücherwagendienst angeschlossen?
          </ul>
        </li>

        <li>
          <b> welche Portokosten fallen an?</b>
          <ul>
            {' '}
            die Portokosten für Deutschland finden Sie hier:{' '}
            <a href="https://custom.buchbutler.de/porto/" target="_blank">
              PORTO
            </a>
          </ul>
          <ul>
            {' '}
            die Portokosten nach Österreich betragen aktuell 5,40 Euro je DHL
            Paket
          </ul>
        </li>

        <li>
          <b> Wie kann ich den Buchbutler bezahlen?</b>
          <ul>
            {' '}
            folgende Zahlarten sind aktuell möglich:
            <br />
            Rechnung, Abrechnung über die BAG, Paypal, Kreditkarte, Lastschrift
            <br />
            die Zahlarten werden Ihnen im Kaufprozess zur Auswahl angezeigt.
          </ul>
        </li>

        <li>
          <b> Wie schnell liefert der Buchbutler?</b>
          <ul>
            {' '}
            der Buchbutler ist ein Barsortiment on Demand und hat daher nur
            wenige Artikel direkt am Lager, dh. die Artikel werden vom
            Buchbutler für Sie besorgt und dann an Sie oder Ihren Kunden
            versendet.
            <br />
            die Lieferzeit der einzelnen Artikel finden Sie jeweils auf der
            Artikeldetailseite
          </ul>
        </li>

        <li>
          <b> Wie teuer ist der Buchbutler?</b>
          <ul>
            {' '}
            den Einkaufspreis und den Rabatt der Artikel finden Sie jeweils auf
            der Artikeldetailseite.
          </ul>
        </li>

        <li>
          <b> Kann ich einen höheren Rabatt bekommen?</b>
          <ul>
            {' '}
            Leider nein, jeder Kunde erhält vom Buchbutler die selben
            Konditionen, egal ob viel oder wenig Umsatz. So ist es für alle
            Buchhändler fair.
          </ul>
        </li>

        <li>
          <b> was finde ich in meinem Kundenkonto?</b>
          <ul>
            {' '}
            eine komplette Übersicht Ihrer Bestellungen mit Ihrem Einkaufspreis,
            Ihrem Rabatt und der entsprechenden MwSt.
          </ul>
          <ul> Ihr Adressebuch mit Liefer- und Rechnungsadressen</ul>
          <ul>
            {' '}
            natürlich können Sie dort auch all Ihre Rechnungen immer wieder
            herunterladen
          </ul>
        </li>

        <li>
          <b> muss ich mich dafür registrieren?</b>
          <ul>
            {' '}
            ja, mit der ersten Bestellung wird automatisch ein Kundenkonto
            erstellt
          </ul>
        </li>

        <li>
          <b> habe ich ein Retourenrecht/Remissionsrecht?</b>
          <ul>
            {' '}
            bitte fragen Sie Ihre Remissionen immer vorab bei unserem
            Kundenservice an unter retoure@buchbutler.de
          </ul>
          <ul>
            {' '}
            genehmigte Retouren senden Sie bitte <u>ausreichend frankiert</u> an
            unser Lager
            <br />
            Moluna GmbH
            <br />
            Buchbutler Retoure
            <br />
            Engberdingdamm 27
            <br />
            48268 Greven
          </ul>
          <ul>
            {' '}
            für die Bearbeitung der Retouren fallen folgende Kosten an:
            <br />
            3% Bearbeitungsgebühr
            <br />
            50 Cent Widereinlagerungspauschale je Exemplar
          </ul>
        </li>

        <li>
          <b> gibt es Besonderheiten bei Artikel aus dem Ausland, z.B. Zoll?</b>
          <ul>
            {' '}
            alles, was Sie beim Buchbutler bestellen wird aus Deutschland
            versendet. Sofern Ihre Lieferanschrift in Deutschland oder der EU
            liegt gibt es keinerlei Zoll Thematiken für Sie.
          </ul>
        </li>

        <li>
          <b> wie werden Steuern auf den Rechnungen ausgewiesen?</b>
          <ul>
            {' '}
            alle Rechnungen mit einer Lieferanschrift in Deutschland enthalten
            ganz normal die ausgewiesener MwSt.
          </ul>
          <ul>
            {' '}
            für EU Lieferländer kann einer innergemeinschaftliche MwSt freie
            Lieferung stattfinden, sofern uns eine gültige USt.ID von Ihnen
            vorliegt. (folgt noch im 1. Halbjahr 2024)
          </ul>
        </li>

        <li>
          <b> wie erhalte ich meine Rechnungen</b>
          <ul>
            {' '}
            Ihre Rechnung erhalten Sie automatisch per Email immer abends am Tag
            der Liefermeldung Ihrer Sendung.
          </ul>
        </li>

        <li>
          <b>
            {' '}
            kann der Buchbutler per Dropshipping Bücher direkt an meine Kunden
            senden?
          </b>
          <ul>
            {' '}
            ja, der Buchbutler bietet Dropshipping an mit den entsprechenden
            Schnittstellen. Bitte wenden Sie sich dazu zu erst per{' '}
            <a href="mailto:service@buchbutler.de?subject=Dropshipping-Anfrage">
              Email
            </a>{' '}
            an unseren Kundenservice
          </ul>
        </li>

        <li>
          <b>
            {' '}
            bietet der Buchbutler Datenschnittstellen an um die Artikel in
            meinen Shop und/oder meine Warenwirtschaft integrieren zu können
          </b>
          <ul>
            {' '}
            ja, der Buchbutler bietet die entsprechenden Schnittstellen. Bitte
            wenden Sie sich dazu zu erst per{' '}
            <a href="mailto:service@buchbutler.de?subject=Buchbutler-Schnittstelle">
              Email
            </a>{' '}
            an unseren Kundenservice
          </ul>
        </li>
      </div>
    );
  }
  initState(base: BasePageState): FAQState {
    let newState: FAQState = {
      ...base,
    };

    return newState;
  }
  getApiReqestUrl(checkOnly: boolean): string {
    return this.state.apiBase + '/Standard.php';
  }

  releaseOneCommand(): void {}
  childDidMount(): void {}
  childDidUnmount(): void {}
  initJSChild(): string {
    return '';
  }
  childDidUpdate(prevProp: any, prevState: any): void {}
  getRightBreadCrumbParts(): JSX.Element {
    return <></>;
  }

  pageHeaderGetter(): string | null {
    return null;
  }
  pageTitleGetter(): string {
    return 'FAQ';
  }
  getBreadCrumb(): JSX.Element {
    return <span>FAQ</span>;
  }
  getType(): string {
    return 'FAQPage';
  }
}
